export default __webpack_public_path__ + "static/media/logo-light.c59fe23c.png";